import React from 'react';
import { SwitchField, SwitchProps } from '@schuettflix/planum-react';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form';

type SwitchFieldValues = {
    [key: string]: boolean;
};

export type SwitchFieldInputProps = Pick<ControllerProps<SwitchFieldValues>, 'name' | 'defaultValue' | 'disabled'> &
    Pick<SwitchProps, 'size' | 'className' | 'type'> & {
        label: string;
        onSwitchFieldChange?: (value: boolean) => void;
        dataTest?: string;
    };

export const SwitchFieldInput = React.forwardRef<HTMLInputElement, SwitchFieldInputProps>(
    (
        { name, defaultValue, label, size, disabled, className, type = 'button', onSwitchFieldChange, dataTest },
        _ref
    ) => {
        const { control } = useFormContext<SwitchFieldValues>();

        return (
            <Controller
                control={control}
                name={name}
                defaultValue={defaultValue}
                render={({ field: { ref, onChange, value, ...field }, fieldState: { error } }) => (
                    <div ref={ref} tabIndex={-1} className="focus:outline-none">
                        <SwitchField
                            {...field}
                            label={label}
                            size={size}
                            className={className}
                            disabled={disabled}
                            checked={value}
                            type={type}
                            error={error?.message}
                            data-test={dataTest}
                            onCheckedChange={checked => {
                                onSwitchFieldChange?.(checked);
                                onChange(checked);
                            }}
                        />
                    </div>
                )}
            />
        );
    }
);
